<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_iv"></a><em>This book is dedicated to our beloved parents<br/>Rosa and Shim’on Saraf, z”l<br/>Marsela-Chaviva and Shlomo Ezra, z”l<br/>May their memory be blessing for us all<br/>With love, Rina and Yoel Saraf</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8f2fcfb6